import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cx7uv97v8k: FaireBrandEntity = {
  token: "b_cx7uv97v8k",
  type: "brand",
  name: "Like Family",
  avatarUrl:
    "https://cdn.faire.com/fastly/2081cdec617131af0b5b4d02f61773dbad664c05d5d98caddd6d8a4967213993.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/36770dad08dc0cac18dc2ab3c1b51482736da9a610769f188259939f9f0ebc5e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2081cdec617131af0b5b4d02f61773dbad664c05d5d98caddd6d8a4967213993.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36770dad08dc0cac18dc2ab3c1b51482736da9a610769f188259939f9f0ebc5e.jpeg",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Like Family is a California craft extra virgin olive olive oil producer. We make fruit-forward, expressive extra virgin olive oil from our own orchard in Carmel Valley and like-minded neighboring California growers. Our oils are varietal-driven, single origin, and importantly, fresh from the new harvest. \n\nThe best chefs know that a heavy splash of the right finishing oil transforms a good dish into a GREAT dish — a raw tomato into a Michelin-starred salad, a simple grilled steak into a trip to Tuscany. Like Family supplies many celebrated Northern California restaurants, but our dream is share our oil — and these moments of sensory revelry — with home cooks and food lovers everywhere!\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:36.650Z",
    importedBy: "entity-db-cli",
  },
};
